<script setup lang="ts">
  import type { OperationLogResponse } from '@/entities/OperationLog';

  import OperationLogsCargos from './OperationLogsCargos.vue';

  defineProps<{
    log: OperationLogResponse;
    formatDate: (value: string) => string;
    formatTime: (value: string) => string;
  }>();
</script>

<template>
  <tr
    class="table-row-hover border-t border-gray-02 align-top transition-colors duration-300 ease-out"
  >
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-nowrap align-top">
      {{ formatDate(log.occurredAt) }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-nowrap align-top">
      {{ formatTime(log.occurredAt) }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-normal break-words align-top">
      {{ log.collaborator.name }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left align-top">
      <OperationLogsCargos :roles="log.collaborator.roles" />
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-nowrap align-top">
      {{ log.ipAddress }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-normal break-words align-top">
      {{ log.documentType }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left whitespace-normal break-words align-top">
      {{ log.event }}
    </td>
    <td class="px-6 py-4.5 text-sm text-gray-07 text-left whitespace-normal break-words align-top">
      {{ log.description }}
    </td>
  </tr>
</template>
